import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {DataSource} from '../data/data-source';

@Component({
    selector: 'ps-table-pager',
    template: `
    @if (shouldShow()) {
      <nav class="ps-table-pagination-nav">
        <ul class="ps-table-pagination pagination">
          <li class="ps-table-page-item page-item" [ngClass]="{disabled: getPage() == 1}">
            <a class="ps-table-page-link page-link" href="#"
              (click)="getPage() == 1 ? false : paginate(1)" aria-label="First">
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">First</span>
            </a>
          </li>
          @for (page of getPages(); track page) {
            <li class="ps-table-page-item page-item"
              [ngClass]="{active: getPage() == page}">
              @if (getPage() == page) {
                <span class="ps-table-page-link page-link"
                  >{{ page }} <span class="sr-only">(current)</span></span>
                }
                @if (getPage() != page) {
                  <a class="ps-table-page-link page-link" href="#"
                  (click)="paginate(page)">{{ page }}</a>
                }
              </li>
            }
            <li class="ps-table-page-item page-item"
              [ngClass]="{disabled: getPage() == getLast()}">
              <a class="ps-table-page-link page-link" href="#"
                (click)="getPage() == getLast() ? false : paginate(getLast())" aria-label="Last">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Last</span>
              </a>
            </li>
          </ul>
        </nav>
      }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PagerComponent implements OnInit {
  @Input() perPage: number;
  @Input() source: DataSource;
  @Output() changePage = new EventEmitter<any>();

  protected pages: Array<any>;
  public page: number;
  protected count = 0;

  ngOnInit(): void {
    this.source.onChanged().subscribe((changes) => {
      this.page = this.source.getPaging().page;
      this.count = this.source.count();

      if (this.isPageOutOfBounce()) {
        this.source.setPage(--this.page);
      }

      this.processPageChange(changes);
      this.initPages();
    });
  }

  /**
   * We change the page here depending on the action performed against data source
   * if a new element was added to the end of the table - then change the page to the last
   * if a new element was added to the beginning of the table - then to the first page
   * @param changes
   */
  processPageChange(changes): void {
    if (changes['action'] === 'prepend') {
      this.source.setPage(1);
    }
    if (changes['action'] === 'append') {
      this.source.setPage(this.getLast());
    }
  }

  shouldShow(): boolean {
    return this.source.count() > this.perPage;
  }

  paginate(page: number): boolean {
    this.source.setPage(page);
    this.page = page;
    this.changePage.emit({page});
    return false;
  }

  getPage(): number {
    return this.page;
  }

  getPages(): Array<any> {
    return this.pages;
  }

  getLast(): number {
    return Math.ceil(this.count / this.perPage);
  }

  isPageOutOfBounce(): boolean {
    return (this.page * this.perPage) >= (this.count + this.perPage) && this.page > 1;
  }

  initPages() {
    const pagesCount = this.getLast();
    let showPagesCount = 4;
    showPagesCount = pagesCount < showPagesCount ? pagesCount : showPagesCount;
    this.pages = [];

    if (this.shouldShow()) {

      let middleOne = Math.ceil(showPagesCount / 2);
      middleOne = this.page >= middleOne ? this.page : middleOne;

      let lastOne = middleOne + Math.floor(showPagesCount / 2);
      lastOne = lastOne >= pagesCount ? pagesCount : lastOne;

      const firstOne = lastOne - showPagesCount + 1;

      for (let i = firstOne; i <= lastOne; i++) {
        this.pages.push(i);
      }
    }
  }
}
